export default "__VITE_ASSET__DJdhnwd$__"